import React from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';


const UserInputField = ({ label, value, onChange, disabled=false }) => {
  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <Box>
        <Typography sx={{ fontFamily: 'Inter', fontSize: '0.8rem', fontWeight: 'bold' }}>
          {label}:
        </Typography>
        <TextField
          fullWidth
          disabled={disabled}
          variant="standard"
          value={value}
          inputProps={{ maxLength: 80 }}
          onChange={onChange}
          sx={{ 
            fontFamily: 'Inter', 
            fontSize: '14px', 
            color: '#005559', 
            '& fieldset': { borderColor: '#005559' }, 
            '&:before': { borderColor: '#005559' }, 
            '&:after': { borderColor: '#005559' } 
          }}
        />
      </Box>
    </Grid>
  );
};

UserInputField.propTypes = {
  lavel: PropTypes.func.isRequired,
  value: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default UserInputField;
